import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { EllipsisLoaderComponent } from './ellipsisloader.component'

@NgModule({
    imports: [CommonModule],
    declarations: [EllipsisLoaderComponent],
    exports: [EllipsisLoaderComponent],
})
export class EllipsisLoaderModule {}
